import React from 'react'
import styled from 'styled-components'
import { LayoutProps } from './props'

export default ({ children }: LayoutProps) => <Root>{children}</Root>

const Root = styled.div`
  height: 100%;
`
